<mat-form-field>
  <mat-label>{{label}}</mat-label>
  <input matInput value="{{value}}" disabled>
  <button mat-icon-button matSuffix #tooltip="matTooltip" [matTooltip]="copyTooltipText" [copy-clipboard]="value"
    (copied)="copied()">
    <mat-icon>content_copy</mat-icon>
  </button>
</mat-form-field>